document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("QuickViewModal");
  const content = document.getElementById("QuickViewContent");

  document.querySelectorAll("[data-open-quick-view]").forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const handle = this.dataset.productHandle;

      modal.classList.add("active");
      content.innerHTML = "Loading...";

      fetch(`/products/${handle}?view=quick-view`)
      .then(res => res.text())
      .then(html => {
        content.innerHTML = html;

        // ✅ Scripts injected via innerHTML don't execute.
        // Manually extract and run the variants script tag.
        const scriptEl = content.querySelector("script");
        if (scriptEl) {
          const newScript = document.createElement("script");
          newScript.textContent = scriptEl.textContent;
          document.body.appendChild(newScript);
        }

        initQuickView();
      });
    });
  });

  document.addEventListener("click", function (e) {
    if (e.target.matches("[data-close-quick-view]")) {
      modal.classList.remove("active");
    }
  });

  function initQuickView() {
    const variants = window.quickViewVariants || [];
    let selectedOptions = variants.length ? [...variants[0].options] : [];

    console.log("🟡 initQuickView called");
    console.log("🟡 Initial selectedOptions:", selectedOptions);

    document.querySelectorAll(".qv-option-values").forEach(group => {
      const firstBtn = group.querySelector(".qv-variant-btn");
      if (firstBtn) firstBtn.classList.add("active");
    });

    function updateVariant() {
      console.log("🔄 updateVariant called, selectedOptions:", selectedOptions);

      const matched = variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );

      console.log("🔄 matched variant:", matched);

      if (!matched) {
        console.warn("❌ No variant matched! Check option values match exactly.");
        return;
      }

      const addBtn = document.querySelector(".qv-add-to-cart");
      if (addBtn) {
        addBtn.dataset.variantId = matched.id;
        console.log("✅ variantId updated on button to:", matched.id);
      }

      const dynamicInput = document.getElementById("QuickViewDynamicVariant");
      if (dynamicInput) dynamicInput.value = matched.id;

      const priceEl = document.querySelector(".qv-current");
      if (priceEl) priceEl.innerText = Shopify.formatMoney(matched.price);

      const inStock = document.querySelector(".qv-instock");
      const outStock = document.querySelector(".qv-outstock");
      if (inStock) inStock.style.display = matched.available ? "" : "none";
      if (outStock) outStock.style.display = matched.available ? "none" : "";
    }

    document.querySelectorAll(".qv-variant-btn").forEach(btn => {
      btn.addEventListener("click", function () {
        const position = parseInt(this.dataset.optionPosition) - 1;
        const value = this.dataset.value;

        console.log(`🖱️ Variant btn clicked — position: ${position}, value: ${value}`);

        selectedOptions[position] = value;
        console.log("🖱️ selectedOptions after click:", selectedOptions);

        this.closest(".qv-option-values")
          .querySelectorAll("button")
          .forEach(b => b.classList.remove("active"));
        this.classList.add("active");

        updateVariant();
      });
    });

    const qtyInput = document.getElementById("QuickViewQty");
    document.querySelector(".qv-minus")?.addEventListener("click", () => {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
    });
    document.querySelector(".qv-plus")?.addEventListener("click", () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });

    const addBtn = document.querySelector(".qv-add-to-cart");
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        const variantId = parseInt(this.dataset.variantId);
        const qty = parseInt(qtyInput.value) || 1;

        console.log("🛒 Add to Cart clicked — variantId:", variantId, "qty:", qty);

        if (!variantId) {
          console.error("❌ variantId is missing or 0!");
          return;
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: qty }),
        })
          .then(res => res.json())
          .then(data => {
  console.log("✅ Cart response:", data);
  modal.classList.remove("active");

  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;

      document.querySelectorAll("cart-counter").forEach(el => {
        el.textContent = count;
        if (count > 0) {
          el.removeAttribute("empty");
        } else {
          el.setAttribute("empty", "");
        }
      });

      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    });
})
          .catch(err => console.error("Add to cart error:", err));
      });
    }
  }

});